import { environment } from '@environments/environment';

export const BASEPATH = environment.apiUrl;
export class AuthApi {
  public static readonly LOGIN = BASEPATH + '/authentication/login';
  public static readonly CHANGE_PASSWORD = BASEPATH + '/authentication/changepassword';
  public static readonly DISABLE_OTP = BASEPATH + '/users/self/otp/disable';
  public static readonly ENABLE_OTP = BASEPATH + '/users/self/otp/activation';
}

export class UserDataApi {
  public static readonly RETRIEVE_USER_DATA = BASEPATH + '/users/self/userdata';
  public static readonly USERS =
    BASEPATH + '/users?email={email}&name={name}&surname={surname}&onlyActive={onlyActive}';
  public static readonly TENANT_USERS = BASEPATH + '/users/tenant?email={email}&name={name}&surname={surname}&onlyActive={onlyActive}';
  public static readonly USER_AVATAR = BASEPATH + '/users/self/avatar';
  public static readonly USER_EMAIL_CONFIRMATION = BASEPATH + '/users/self/mail/confirmation?uuid={uuid}';
  public static readonly USER_UPDATE_LANG = BASEPATH + '/users/self/lang/update';
  public static readonly USER_UPDATE_PROFILE = BASEPATH + '/users/self/profile/update';
  public static readonly USER_ACCEPT_PRIVACY = BASEPATH + '/users/self/privacy/accept';
  public static readonly USER_SETTINGS = BASEPATH + '/users/self/settings';
  public static readonly USER_UPDATE_SETTINGS = BASEPATH + '/users/self/settings/update';
  public static readonly GET_DAY_BEFORE_REMINDER = BASEPATH + '/users/self/tenant/dayBeforeReminder';
  public static SWITCH_USER = BASEPATH + '/switch';
  public static EXIT_SWITCH = BASEPATH + '/exit-switch';
  public static readonly ALL_PERSONS_TENANTS = BASEPATH + '/users/all';
  public static readonly PROPERTIES_LOAD = BASEPATH + '/users/self/properties/load/{propName}';
  public static readonly PROPERTIES_UPDATE = BASEPATH + '/users/self/properties/update';
}

export class DepartmentApi {
  public static readonly LOAD_DEPARTMENT = BASEPATH + '/department?departmentName=';
  public static readonly SAVE_DEPARTMENT = BASEPATH + '/department/save';
  public static readonly DELETE_DEPARTMENT = BASEPATH + '/department/delete';
  public static readonly DELETE_PERSONS_FROM_DEPARTMENT = BASEPATH + '/department/persons/delete';
  public static readonly DELETE_PERSON_FROM_DEPARTMENT = BASEPATH + '/department/person/delete';
  public static readonly BELONGS_DEPARTMENT = BASEPATH + '/department/belongs';
  public static readonly LIST_DEPARTMENT = BASEPATH + '/department/list';
  public static readonly LIST_DEPARTMENT_PERSONS = BASEPATH + '/department/persons?departmentName=';
  public static readonly WF_SEARCH_DEPARTMENT = BASEPATH + '/department/wf-search';
}

export class ProcessApi {
  public static readonly PROCESS_APPROVAL_START = BASEPATH + '/users/self/process/approval';
  public static readonly PROCESS_METADATA =
    BASEPATH + '/users/self/process/metadata?processId={processId}&fristVersion={fristVersion}&uuid={uuid}&removeDisabledSigners={removeDisabledSigners}&generateGroupId={generateGroupId}&groupId={groupId}';
  public static readonly PROCESS = BASEPATH + '/users/self/process';
  public static readonly PROCESS_WITH_DOCS = BASEPATH + '/users/self/process/with-docs';
  public static readonly PROCESS_LINKED_PROCESSES = BASEPATH + '/users/self/process/linkedProcesses/{groupId}';
  public static readonly PROCESS_DRAFT_LIST = BASEPATH + '/users/self/process/draft/list';
  public static readonly PROCESS_DRAFT_SAVE = BASEPATH + '/users/self/process/draft/save';
  public static readonly PROCESS_DRAFT_EDIT = BASEPATH + '/users/self/process/draft/edit/{id}';
  public static readonly PROCESS_DRAFT_DELETE = BASEPATH + '/users/self/process/draft/delete';
  public static readonly PROCESS_DRAFT_LOAD = BASEPATH + '/users/self/process/draft/load/{uuid}';
  public static readonly REOPEN_TASK = BASEPATH + '/users/self/process/reopen';
  public static readonly PROCESS_UPLOAD_ATTACHMENT = BASEPATH + '/users/self/tasks/{processId}/uploadAttachment';
  public static readonly PROCESS_EMAILS_READ =
    BASEPATH + '/users/self/process/emails/{processId}?page={page}&size={size}';
  public static readonly PROCESS_EMAILS_REFRESH = BASEPATH + '/users/self/process/emails/{processId}/refresh';
  public static readonly PROCESS_EMAILS_COUNT = BASEPATH + '/users/self/process/emails/count?wfIds={processIdList}';
  public static readonly PROCESS_DRAFT_EXIST = BASEPATH + '/users/self/process/draft/exist/{templateName}';
  public static readonly PROCESS_PROTOCOL_NEXT =
    BASEPATH + '/users/self/process/protocol/next/{documentSubType}?processSpecType={processSpecType}';
  public static readonly PROCESS_SIGNERS_CHECK = BASEPATH + '/users/self/process/signers/check';
  public static readonly PREVIOUS_VERBAL = BASEPATH + '/users/self/process/last-verbals';
  public static readonly REOPENED_PREVIOUS_VERBAL = BASEPATH + '/users/self/process/reopen-last-verbal/';
  public static readonly GENERATE_FRONTESPIZIO = BASEPATH + '/users/self/process/generate-frontespizio';
  public static readonly CHECK_PROCESS_TYPE_VALIDITY =
    BASEPATH + '/users/self/tasks/check-process-type/{processId}?processType={processType}';
}

export class TaskApi {
  public static readonly TASK_INFO = BASEPATH + '/users/self/tasks/{taskId}/info?completed={completed}';
  public static readonly TASK_COMPLETE = BASEPATH + '/users/self/tasks/{taskId}/complete';
  public static readonly TASK_REFUSE = BASEPATH + '/users/self/tasks/refuse';
  public static readonly TASK_CANCEL = BASEPATH + '/users/self/tasks/cancel';
  public static readonly TASK_REMIND = BASEPATH + '/users/self/tasks/remind/{signerIndex}';
  public static readonly TASK_REMIND_URL = BASEPATH + '/users/self/tasks/{taskId}/remind-url/{signerIndex}';
  public static readonly SIGNATURES_HISTORY = BASEPATH + '/users/self/signatures';
  public static readonly TASK_GET_OTP = BASEPATH + '/users/self/tasks/send/otp';
  public static readonly TASK_UPDATE_DELEGATE = BASEPATH + '/users/self/tasks/{processId}/updateDelegate';
  public static readonly TASK_CHECK_OWNERSHIP = BASEPATH + '/users/self/tasks/{processId}/checkExtendedOwnership';
  public static readonly TASK_DOC_SIZE = BASEPATH + '/users/self/tasks/{processId}/docSize';
  public static readonly PROCESS_BUSINESS_STATUS_UPDATE = BASEPATH + '/users/self/tasks/{processId}/status/{businessStatus}';
  public static readonly TASK_FEQ_ONESHOT_INIT = BASEPATH + '/users/self/tasks/{processId}/feq-oneshot/init';
}
export class ExternalTaskApi {
  public static readonly TASK_INFO = BASEPATH + '/external/tasks/{processId}/info?token={token}';
  public static readonly TASK_ACTIONS = BASEPATH + '/external/tasks/{processId}/actions';
  public static readonly TASK_COMPLETE = BASEPATH + '/external/tasks/{processId}/complete';
  public static readonly TASK_UPLOAD_ATTACHMENT = BASEPATH + '/external/tasks/{processId}/uploadDoc';
  public static readonly TASK_VERIFY_ATTACHMENT =
    BASEPATH + '/external/tasks/{processToken}/validateSignature/separaresign';
  public static readonly TASK_VALIDATE_SIGNATURE = BASEPATH + '/external/tasks/{processId}/validateSignature';
  public static readonly TASK_REFUSE = BASEPATH + '/external/tasks/refuse';
  public static readonly TASK_COMPLETE_TO_SIGN = BASEPATH + '/external/tasks/{taskId}/complete/sign';

  public static readonly TASK_COMPLETE_TO_SIGN_SEPARATE_SIGNATURE =
    BASEPATH + '/external/tasks/{taskId}/separateSignature/complete';
  public static readonly TASK_GET_OTP = BASEPATH + '/external/send/otp/{tenant}';
  public static readonly TASK_RESEND_OTP = BASEPATH + '/external/tasks/{processToken}/resend/otp';
  public static readonly GET_THEME_CONFIGURATION = BASEPATH + '/external/theme/{tenant}';
  public static readonly PROCESS_UPLOAD_ATTACHMENT = BASEPATH + '/external/tasks/{processToken}/uploadAttachment';
   public static readonly GET_PROCESS_ROLE_TRANSLATIONS = BASEPATH + '/external/process-roles/{processRoleKey}/translations';
  public static readonly TASK_FEQ_ONESHOT_INIT = BASEPATH + '/external/tasks/{processId}/feq-oneshot/init?token={token}';
  public static readonly LINK_SHORTENER_GET = BASEPATH + '/external/s/{linkCode}';

}

export class DocumentApi {
  public static readonly DOCUMENTS = BASEPATH + '/users/self/documents?size={size}&page={page}';
  public static readonly DOCUMENT_DOWNLOAD = BASEPATH + '/users/self/documents/{nodeRefId}?processId={processId}&zipIfCades={zipIfCades}';
  public static readonly ALL_VERBAL_DOCUMENTS_DOWNLOAD = BASEPATH + '/users/self/documents/get-files-first-version/{workflowId}';
  public static readonly DOCUMENT_DOWNLOAD_ZIP = BASEPATH + '/users/self/documents/export';
  public static readonly DOCUMENT_HISTORY =
    BASEPATH + '/users/self/documents/{nodeRefId}/history?processId={processId}';
  public static readonly DOCUMENT_HISTORY_EXPORT =
    BASEPATH + '/users/self/documents/{worflowId}/history/export/{nodeRefId}';
  public static readonly DOCUMENT_SUBTPYE = BASEPATH + '/users/self/documents/subtypes';
  public static readonly DOCUMENT_TYPE_LIST = BASEPATH + '/users/self/documents/type/list/{tenant}';
  public static readonly CREATE_DOCUMENT_TYPE = BASEPATH + '/users/self/documents/type/create/{tenant}';
  public static readonly EDIT_DOCUMENT_TYPE = BASEPATH + '/users/self/documents/type/edit/{tenant}';
  public static readonly DELETE_DOCUMENT_TYPE = BASEPATH + '/users/self/documents/type/delete/{tenant}/{id}';
  public static readonly DOCUMENT_SPECTPYE = BASEPATH + '/users/self/documents/spectypes/{subtype}';
  public static readonly DOCUMENT_METADATA =
    BASEPATH + '/users/self/documents/{nodeRefId}/metadata?processId={processId}';
  public static readonly DOCUMENT_METADATA_WITHNOTES =
    BASEPATH + '/users/self/documents/{nodeRefId}/metadata-with-notes?processId={processId}';
  public static readonly DOCUMENT_INFO = BASEPATH + '/users/self/documents/{nodeRefId}/info?processId={processId}';
  public static readonly DOCUMENT_METADATA_FORTYPE = BASEPATH + '/users/self/documents/types/{docType}/metadata';

  public static readonly EXTERNAL_DOCUMENT_DOWNLOAD = BASEPATH + '/external/document/{docId}';

  public static readonly EXTERNAL_DOCUMENT_METADATA =
    BASEPATH + '/external/tasks/{processToken}/metadata/{nodeRefId}?token={token}';
  public static readonly EXTERNAL_DOCUMENT_METADATA_WITHNOTES =
    BASEPATH + '/external/tasks/{processToken}/metadata-with-notes/{nodeRefId}?token={token}';

  public static readonly DOCUMENT_METADATA_EXPORT =
    BASEPATH + '/users/self/documents/metadata/csv?light={light}';

  public static readonly DOCUMENT_SUBTPYE_EXPIRATIONDATE = BASEPATH + '/users/self/documents/subtypes/expirationDate';

  public static readonly DOCUMENT_TYPE_SAVE = BASEPATH + '/users/self/documents/type/save?tenant={tenant}';

  public static readonly DOCUMENT_SUBTYPE_METADATA = BASEPATH + '/users/self/documents/docSubType/{docSubType}/metadata';
  public static readonly DOCUMENT_SUBTYPE_COUNT = BASEPATH + '/users/self/documents/subtypes/count';

}

export class TagApi {
  public static readonly CREATE_TAG = BASEPATH + '/users/self/documents/{docId}/tag?tagValue={tagValue}';
  public static readonly DELETE_TAG = BASEPATH + '/users/self/documents/{docId}/tag/{tagId}';
}

export class TenantApi {
  public static readonly TENANT_CREATION = BASEPATH + '/tenant';
  public static readonly TENANT_CREATION_CONFIRM = BASEPATH + '/tenant/confirm';
  public static readonly TENANT_GET_PERSONS = BASEPATH + '/tenant/persons';
  public static readonly TENANT_GET_CONFIG = BASEPATH + '/tenant/config';

  public static readonly INVITE_USER_CREATION_CONFIRM = BASEPATH + '/tenant/user/invite/confirm?token={token}';
  public static readonly GET_THEME_CONFIGURATION = BASEPATH + '/tenant/theme';
  public static readonly GET_TENANT_PROPERTY = BASEPATH + '/tenant/tenant-properties/{tenant}/{propName}';
  public static readonly GET_TENANT_PROPERTIES = BASEPATH + '/tenant/tenant-properties/{tenant}';
  public static readonly GET_ALL_TENANTS = BASEPATH + '/tenant/list';
  public static readonly CREATE_NEW_TENANT_PROPERTY = BASEPATH + '/tenant/tenant-properties/{tenant}';
  public static readonly UPDATE_TENANT_PROPERTY = BASEPATH + '/tenant/tenant-properties/{tenant}';
  public static readonly DELETE_TENANT_PROPERTY = BASEPATH + '/tenant/tenant-properties/{tenant}/{propertyId}';
  public static readonly GET_TENANT_FLAGS = BASEPATH + '/tenant/flag-list';
  public static readonly GET_PROFILE_LIST = BASEPATH + '/tenant/profile-list';
  public static readonly UPDATE_TENANT_FLAGS = BASEPATH + '/tenant/flag-list';
  public static readonly GET_TENANT_PROCESS_ROLES = BASEPATH + '/tenant/process-roles';
  public static readonly CREATE_UPDATE_PROCESS_ROLE = BASEPATH + '/tenant/process-roles/createUpdate';
  public static readonly DELETE_PROCESS_ROLE = BASEPATH + '/tenant/process-roles/{tenant}/{processRoleId}'
  public static readonly GET_PROCESS_ROLE_TRANSLATIONS = BASEPATH + '/tenant/process-roles/{processRoleKey}/translations';
  public static readonly TENANT_GRANT = BASEPATH + '/tenant/grant/{tenant}/{grantName}';
}

export class AddressApi {
  public static readonly RETRIEVE_SIGNERS =
    BASEPATH + '/users/self/address/signers?filter={filter}&internal={internal}&external={external}&email={email}';
  public static readonly ADDRESS_SEARCH =
    BASEPATH +
    '/users/self/address?internal={internal}&addressType={addressType}&vat={vat}&denomination={denomination}&fiscalCode={fiscalCode}&clientCode={clientCode}&page={page}&size={size}';
  public static readonly ADDRESS = BASEPATH + '/users/self/address';
  public static readonly ADDRESS_ID = BASEPATH + '/users/self/address/{addressId}';
  public static readonly ADDRESS_IMPORT = BASEPATH + '/users/self/address/import';
  public static readonly ADDRESS_TEMPLATE = BASEPATH + '/users/self/address/import/template';
  public static readonly EXPORT_ADDRESS = BASEPATH + '/users/self/address/export';
}

export class NotificationApi {
  public static readonly NOTIFICATIONS = BASEPATH + '/users/self/notifications';
  public static readonly NOTIFICATION_READ = BASEPATH + '/users/self/notifications/{notificationId}/read';
  public static readonly NOTIFICATION = BASEPATH + '/users/self/notifications/{notificationId}';
  public static readonly NOTIFICATIONS_DELETE = BASEPATH + '/users/self/notifications/delete';
  public static readonly HAS_NEW_NOTIFICATION = BASEPATH + '/users/self/notifications/new';
}

export class PaymentApi {
  public static readonly PAYMENT_REQUEST = BASEPATH + '/users/self/payment/tenant/profile/{tenantProfile}/request';
  public static readonly PAYMENT_EXECUTE = BASEPATH + '/users/self/payment/tenant/profile/{tenantProfile}/execute';
  public static readonly PAYMENT_USER_REQUEST = BASEPATH + '/users/self/payment/tenant/user/request?email={email}';
  public static readonly PAYMENT_USER_EXECUTE = BASEPATH + '/users/self/payment/tenant/user/execute';
}

export class SsiApi {
  public static readonly CREATE_MAIL = BASEPATH + '/users/wallet/mail';
  public static readonly GET_EMAIL = BASEPATH + '/users/wallet/mail';
  public static readonly VERIFY_MAIL = BASEPATH + '/users/wallet/mail/verify';
  public static readonly CREATE_PIN = BASEPATH + '/users/wallet/pin';
  public static readonly VERIFY_PIN = BASEPATH + '/users/wallet/pin/verify';
  public static readonly CREATE_PERSONAL_ID = BASEPATH + '/users/wallet/personalid';
  public static readonly CREATE_ORGANIZZATION = BASEPATH + '/users/wallet/organization';
  public static readonly ACCEPT_PERSONAL_ID = BASEPATH + '/users/wallet/personalid/{id}/accept';
  public static readonly DOWNLOAD_CREDENTIAL = BASEPATH + '/users/wallet/{id}';
}

export class AdsApi {
  public static readonly SEND_ADS_EMAIL = BASEPATH + '/external/notify/subscription?email={email}';
}

export class PdfApi {
  private static readonly PDF_BASE_PATH = BASEPATH + '/pdf';
  public static readonly VERIFY_PDF_SIGNATURE = PdfApi.PDF_BASE_PATH + '/verify-signature';
  public static readonly GET_PDF_ACCESS_PERMISSION = PdfApi.PDF_BASE_PATH + '/access-permissions';
  public static readonly DOES_PDF_ALLOW_SIGNATURE = PdfApi.PDF_BASE_PATH + '/access-permissions/allow-signature';
  public static readonly DOES_PDF_GOT_PASSWORD = PdfApi.PDF_BASE_PATH + '/got-password';
  public static readonly CONVERT_PDF = PdfApi.PDF_BASE_PATH + '/convert';
  public static readonly GET_PDF_TYPE = PdfApi.PDF_BASE_PATH + '/type';
  public static readonly GET_PDF_FLAVOUR = PdfApi.PDF_BASE_PATH + '/pdf-flavour';
  public static readonly POST_PDF_PARSE = PdfApi.PDF_BASE_PATH + "/parse"
  public static readonly CHECK_PDF = PdfApi.PDF_BASE_PATH + '/check-pdf';
}

export class EmailApi {
  public static readonly SEND_INVITE_EMAIL = BASEPATH + '/tenant/user/invite/reminderMail';
}

export class AssertionApi {
  private static readonly ASSERTION_BASE_PATH = BASEPATH + '/assertion';
  public static readonly CREATE_EXTERNAL = AssertionApi.ASSERTION_BASE_PATH + '/create/external';
  public static readonly CREATE_INTERNAL = AssertionApi.ASSERTION_BASE_PATH + '/create/internal';
  public static readonly EXIST = AssertionApi.ASSERTION_BASE_PATH + '/exist';
  public static readonly EXIST_VALID = AssertionApi.ASSERTION_BASE_PATH + '/exist/valid';
  public static readonly SEND_OTP = AssertionApi.ASSERTION_BASE_PATH + '/load/sendOtp';
  public static readonly LOAD = AssertionApi.ASSERTION_BASE_PATH + '/load/{confirmCode}';
  public static readonly CONFIRM = AssertionApi.ASSERTION_BASE_PATH + '/load/confirm';
}

export class ExternalAssertionApi {
  private static readonly ASSERTION_BASE_PATH = BASEPATH + '/external/assertion';
  public static readonly LOAD_EXTERNAL =
    ExternalAssertionApi.ASSERTION_BASE_PATH + '/load/{confirmCode}/{tenantDomain}';
  public static readonly SEND_OTP_EXTERNAL = ExternalAssertionApi.ASSERTION_BASE_PATH + '/load/sendOtp/{tenantDomain}';
  public static readonly CONFIRM_EXTERNAL = ExternalAssertionApi.ASSERTION_BASE_PATH + '/load/confirm/{tenantDomain}';
}

export class FormApi {
  private static readonly FORM_BASE_PATH = BASEPATH + '/users/self/form';
  public static readonly VALIDATOR = FormApi.FORM_BASE_PATH + '/validator/{formName}';
}
export class SavedSearchApi {
  public static readonly BASE_PATH = BASEPATH + '/users/self/savedSearch';
}

export class PhysicalSecurityApi {
  public static readonly PHYSICAL_SECURITY_BASE_PATH = BASEPATH + '/users/self/physical-security';
  public static readonly CLOSE_TASK =
    PhysicalSecurityApi.PHYSICAL_SECURITY_BASE_PATH + '/close-task/{processId}/{sysId}'; // sysId: documentSubject
}

export class DashboardApi {
  public static readonly GET_DASHBOARD_DATA = BASEPATH + '/analytic-dashboard?fromDate={fromDate}&toDate={toDate}';
  public static readonly GET_PROCESSES_DATA = BASEPATH + '/analytic-dashboard/processes?fromDate={fromDate}&toDate={toDate}';
}

export class AmmDashboardApi {
  public static readonly AMM_DASHBOARD_BASE_PATH = BASEPATH + '/amm-dashboard';
  public static readonly GET_MAINTENANCE_CONFIG = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/maintenance-config';
  public static readonly UPDATE_MAINTENANCE_CONFIG = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/maintenance-config';
  public static readonly UPLOAD_THEME = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/upload-theme/{tenant}';
  public static readonly DOWNLOAD_THEME = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/download-theme/{tenant}';
  public static readonly CHANGE_PERSON_TENANT = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/user-tenant';
  public static readonly USER_TENANT_MIGRATIONS =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/user-tenant/migrations';
  public static readonly RETRY_USER_TENANT_MIGRATION =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/user-tenant/migrations/{migrationStateId}/retry';
  public static readonly REVERT_USER_TENANT_MIGRATION =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/user-tenant/migrations/{migrationStateId}/revert';
  public static readonly DELETE_USER_TENANT_MIGRATION =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/user-tenant/migrations/{migrationStateId}';
  public static readonly UPDATE_TENANT_STATE = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/tenant-state';
  public static readonly GET_TENANT_STATE = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/tenant-state/{tenant}';
  public static readonly GET_TENTANT_DAYS_BEFORE_REMINDER =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/tenant-day-before-reminder/{tenant}';
  public static readonly GET_TENANT_ADDABLE_METADATA =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/addable-metadata/{tenant}';
  public static readonly ADD_TENANT_METADATA = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/add-metadata/{tenant}';
  public static readonly DOCUMENT_SUBTYPE_EXPIRATIONDATE =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/documents/subtypes/expirationDate/{tenant}';
  public static readonly GET_TENANT_TEMPLATES = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/templates/{tenant}';
  public static readonly UPDATE_TENANT_TEMPLATES = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/templates/{tenant}';
  public static readonly DELETE_TENANT_TEMPLATE = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/templates/{tenant}/{templateId}';
  public static readonly UPDATE_TENANT_SETTINGS = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/settings/{tenant}';
  public static readonly GET_ALL_DOCUMENT_TYPES = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/doctype-list';
  public static readonly GET_ALL_PROCESS_ROLES = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/process-roles';
  public static readonly SHARED_TENANT = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/shared-tenants';

  public static readonly GET_PROCESS_PAGE = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/process/page/{tenant}?page={page}&size={size}&withError={withError}';
  public static readonly EXECUTE_CALLBACK = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/process/callback/{tenant}/{processId}';
  public static readonly CONSERVATION_STATUS = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/process/conservation-status/{tenant}/{processId}';
  public static readonly CONSERVATION_RESTART = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/process/conservation-restart/{tenant}/{processId}';
  public static readonly EDITABLE_LABELS = AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/editable-labels';
  public static readonly EDITABLE_LABEL_TRANSLATIONS =
    AmmDashboardApi.AMM_DASHBOARD_BASE_PATH + '/editable-labels/{tenant}/{key}/translations';
}

export class FulfillmentApi {
  private static readonly FULFILLMENT = BASEPATH + '/fulfillment';
  public static readonly FULFILLMENT_REGISTRY = FulfillmentApi.FULFILLMENT + '/registry';
  public static readonly FULFILLMENT_REGISTRY_ID = FulfillmentApi.FULFILLMENT + '/registry/{registryId}';
  public static readonly FULFILLMENT_UPLOAD_CSV = FulfillmentApi.FULFILLMENT + '/upload/{tenant}/{year}';
  public static readonly FULFILLMENT_UNREGISTERED = FulfillmentApi.FULFILLMENT + '/unregistered';
  public static readonly FULFILLMENT_UNREGISTERED_TENANT = FulfillmentApi.FULFILLMENT + '/unregistered/{tenant}';
  public static readonly FULFILLMENT_SEARCH = FulfillmentApi.FULFILLMENT + '/search';
  public static readonly FULFILLMENT_LIST_TENANT = FulfillmentApi.FULFILLMENT + '/list/{tenant}';
  public static readonly FULFILLMENT_DELETE = FulfillmentApi.FULFILLMENT + '/{tenant}';
  public static readonly FULFILLMENT_UPDATE_TERM_REGISTRY = FulfillmentApi.FULFILLMENT + '/term/{fulfillmentTermRegistryId}/update';
  public static readonly FULFILLMENT_REGISTRIES = FulfillmentApi.FULFILLMENT + '/registries';
  public static readonly FULFILLMENT_REGISTRIES_ROOTS = FulfillmentApi.FULFILLMENT + '/registries/roots';
  public static readonly FULFILLMENT_REGISTRIES_TAXFILE = FulfillmentApi.FULFILLMENT + '/registries/taxFile/{registryId}';
}
